import {
    forEach,
    filter,
    includes,
    assign,
    uniqBy
} from "lodash";

import collectionRepository from "rapid/collectionRepository";

let globalDependencies = [
    "$q",
    "$stateParams",
    "$state",
    "$filter",
    "$rootScope",
    "$log",
    "$auth",
    "$mdDialog",
    "$mdToast",
    "gettext"
];

class ActiveController {

    constructor($injector, childDependencies = []) {

        "ngInject";

        this.$injector = $injector;

        try {
            this.importDependencies(childDependencies);
        } catch (e) {
            //this.$log.error(e);
            console.log(e);
        }

        this._componentId = angular.copy(Math.random().toString(36).substr(2, 10));
        this.componentId = `${this.constructor.name}-${this._componentId}`;

        this.translate = (key) => this.$filter("translate")(key);

        if (this.$stateParams.uri) {
            this.uri = this.$filter("decodeUri")(this.$stateParams.uri);
        }

        if (this.$auth.isAuthenticated()) {
            //this.isSuperadmin = this.$auth.getUser().permissions.indexOf("superadmin") !== -1;
        }

        this.noData = false;

    }

    getComponentId(suffix) {
        suffix = suffix ? `-${suffix}` : "";
        return `#${this.componentId}${suffix}`;
    }

    $getDataBeforeRun(queries) {
        this.controllerReady = false;
        let deferred = this.$q.defer();
        this.$q.all(queries)
            .then(response => deferred.resolve(response))
            .then(() => this.controllerReady = true);
        return deferred.promise;
    }

    $setDataAfterRun(response) {
        this.tableConfiguration.next_uri = response.next_uri;
        this.objects = uniqBy([...this.objects, ...(response.objects || response)], "uri");
        this.objects.length === 0 && (this.noData = true);
    }

    importDependencies(childDependencies) {

        try {
            let duplicatedDependencies = [], toApply = [];

            let executeApply = (dependenciesToApply) =>
                forEach(dependenciesToApply, dependence => this[dependence] = this.$injector.get(dependence));

            executeApply(globalDependencies);

            filter(childDependencies, (dependence) => includes(globalDependencies, dependence) ?
                duplicatedDependencies.push(dependence) :
                toApply.push(dependence));

            executeApply(toApply);

            if (duplicatedDependencies.length) {
                return this.$log.warn("Warning, you have duplicated dependencies in your child controller based on $controller, there was not implemented but for Improved legibility your code, remove it.", duplicatedDependencies);
            }
        } catch (error) {
            this.$log.error("There is something wrong in your dependencies and ActiveController can't include it.", childDependencies, this, error);
            throw error;
        }
    }

    $openModal(modalName, size, config) {
        return this.$uibModal.open(
            config ?
                assign({component: modalName, size: size || "lg"}, config) :
                {component: modalName, size: size || "lg"}
        );
    }

    $closeModal($event) {
        $event.preventDefault();
        this.close({$value: "cancel"});
    }

    $notify(key, state) {
        this.ngNotify.set(this.translate(key.toUpperCase()), state);
    }

    $getCollection($uri) {
        return collectionRepository.collection[$uri || this.uri];
    }

}

export default ActiveController;



// WEBPACK FOOTER //
// ./rapid/controller.js